import React from "react";
import { NavLink } from "react-router";
import logo1 from "../../data/logo.PNG"
const Footer = () => {
  return (
    <footer className="bg-red-800 text-white py-6">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        
        {/* Logo Section */}
        <div className="flex items-center space-x-3">
          <img src={logo1} alt="Website Logo" className="w-12 h-12" />
          <span className="text-xl font-semibold">GRIM</span>
        </div>

        {/* Useful Links */}
        <div className="lg:ml-20">
          
          <ul className=" md:flex space-x-6 text-white">
          <li><NavLink to={"/"} className="hover:text-red-500">Home</NavLink></li>
          <li><NavLink to={"/AboutUs"} className="hover:text-red-800">About Us</NavLink></li>
          <li><NavLink to={"/Products"} className="hover:text-red-800">Products</NavLink></li>
          <li><NavLink to={"/ContetUs"} className="hover:text-red-800">ContactUs</NavLink></li>
        
        </ul>
        </div>

        {/* Contact Section */}
        <div className="text-center md:text-right">
          <p>Email: energygrim93@gmail.com</p>
          <p>Phone: +91 8708274819</p>
        </div>

      </div>
      <div className="text-center mt-6 text-gray-400">
        <p>&copy; {new Date().getFullYear()} Your Company. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;